
<template>
  <b-container fluid class="full-height">
    <b-row class="full-height">
      <b-col lg="5" style="overflow-y: auto; padding-left: 45px" class="full-height">
        <b-table-simple
            ref="assignedPermissions"
            :items="filteredlocalAssignedPermissions"
        >
          <template>
            <hr style="margin-top: 0px; margin-bottom: 12px;">

            <div style="margin-bottom: 12px;" class="d-flex justify-content-between">
              <div class="">
                <slot name="toolButton1">
                  <b-btn v-if="showSearch"
                         :variant="searchAssignedPermissionsVisible ? 'plm-toolbar-selected' : 'plm-toolbar-secondary'"
                         @click="searchAssignedPermissionsVisibleClick">
                    <font-awesome-icon icon="search"/>
                  </b-btn>
                </slot>
              </div>
              <div class="">
                <label class="m-0 pt-2" style="font-weight: bold">Assigned permissions</label>
              </div>
              <div class="">
              </div>
            </div>
            <hr style="margin-top: 12px; margin-bottom: 12px; border: 1px solid lightgrey;"
                v-if="searchAssignedPermissionsVisible">

            <b-row class="no-gutters pl-0 pt-0 my-2" v-if="searchAssignedPermissionsVisible">
              <div class="input-group" :class="'col-auto pl-0 pr-0 ' + (searchBarClass ? searchBarClass : '')">
                <div class="d-flex pt-1 pb-1" style="line-height: unset">
                  <div style="width: 0px">
                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">
                                  <font-awesome-icon :icon="['fa', 'search']"/>
                              </span>
                  </div>
                  <b-form-input class="mr-1 ml-1 permissionSearchBar"
                                autocomplete="off"
                                style="padding-left: 32px; min-width: 300px; max-width: 300px;"
                                placeholder=""
                                :value="searchAssignedPermissionsInput"
                                @keydown="(event) =>onKeyUp(event, 'assigned')"
                                @click="assignData('whichSearchBarIsUsed', 'searchAssignedPermissions')"
                                ref="query_v1"
                  ></b-form-input>
                  <div style="width: 0px; text-overflow: clip;">
                              <span style="position: relative; top:7px; margin-left: -24px">
                                <a href="#" @click="clearClickedAssignedPermissions" ref="clearLink"
                                   :class="statusColor" style="position: relative; top:1px"
                                   v-if="lastQuery===searchAssignedPermissionsInput && searchAssignedPermissionsInput !== ''">
                                    <font-awesome-icon :icon="['fa', 'times']" transform class="pr-2"/>
                                </a>
                              </span>
                  </div>
                  <div class="mx-1">
                    <span class="input-group-text">{{ filteredlocalAssignedPermissions.length}}</span>
                  </div>
                </div>
              </div>
            </b-row>
            <b-tr sticky-column
                  v-if="filteredlocalAssignedPermissions.length > 0">
              <b-td>
                <b-container class="p-0">
                  <b-row no-gutters>
                    <b-col cols="1">
                      <b-form-checkbox
                          :class="readOnly ? 'd-none' : 'd-block'"
                          @change="changeAllAssignedPermissionsCheckbox"
                          :disabled="filteredlocalAssignedPermissions[0].disabledCheckbox"
                          :value="true"
                          :checked="isChecked"
                          :unchecked-value="false"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col style="font-weight: bold;" v-if="localAssignedPermissionsStatus === false">
                      Select all
                    </b-col>
                    <b-col style="font-weight: bold;" v-else>
                      Unselect All
                    </b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
            <b-tr sticky-column v-for="(row,index) in filteredlocalAssignedPermissions" :key="row.code">
              <b-td>
                <b-container class="p-0">
                  <b-row no-gutters>
                    <b-col cols="1">
                      <b-form-checkbox
                          v-if="row"
                          :name="'assigned-status-' + index"
                          @change="onSelectedAssignedPermission"
                          :class="readOnly ? 'd-none' : 'd-block'"
                          :disabled="row.disabledCheckbox"
                          v-model="row.status"
                          :value="true"
                          :unchecked-value="false"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col>
                      <span v-if="row.customLabel">{{ row.customLabel }}</span>
                      <span v-else>{{ row.label }}</span>
                    </b-col>
                  </b-row>
                </b-container>
              </b-td>
            </b-tr>
          </template>
        </b-table-simple>
      </b-col>

      <b-col class="text-center arrow-roles-height">
        <b-button
            :disabled="readOnly || !isListRightActive && !isListLeftActive"
            data-test-path="move-item"
            @click="moveItem()"
            class="button-arrow"
            variant="plm-action"
        >
          <font-awesome-icon
              class="arrow d-none d-lg-block"
              v-if="isListRightActive"
              icon="arrow-left"
          />
          <font-awesome-icon
              class="arrow d-none d-lg-block"
              v-else-if="isListLeftActive"
              icon="arrow-right"
          />
          <font-awesome-icon
              class="arrow d-none d-lg-block"
              v-else
              icon="arrow-left"
          />
          <font-awesome-icon
              class="arrow d-block d-lg-none"
              v-if="isListRightActive"
              icon="arrow-up"
          />
          <font-awesome-icon
              class="arrow d-block d-lg-none"
              v-else-if="isListLeftActive"
              icon="arrow-down"
          />
        </b-button>
      </b-col>

      <b-col lg="5" style="overflow-y: auto; padding-right: 45px" class="full-height">
        <b-container class="p-0">
          <b-row>

            <b-col>
              <hr style="margin-top: 0px; margin-bottom: 12px;">

              <div class="d-flex justify-content-between">
                <div class="">
                  <slot name="toolButton1">
                    <b-btn v-if="showSearch"
                           :variant="searchAvailablePermissionsVisible ? 'plm-toolbar-selected' : 'plm-toolbar-secondary'"
                           @click="searchAvailablePermissionsVisibleClick">
                      <font-awesome-icon icon="search"/>
                    </b-btn>
                  </slot>
                </div>
                <div class="">
                  <label class="m-0 pt-2" style="font-weight: bold">Available permissions</label>
                </div>
                <div class="">
                </div>
              </div>
              <hr style="margin-top: 12px; margin-bottom: 12px; border: 1px solid lightgrey;">
              <b-row class="no-gutters pl-0 pt-0 my-2" v-if="searchAvailablePermissionsVisible">
                <div class="input-group" :class="'col-auto pl-0 pr-0 ' + (searchBarClass ? searchBarClass : '')">
                  <div class="d-flex pt-1 pb-1 ml-1" style="line-height: unset">
                    <div style="width: 0px">
                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">
                                  <font-awesome-icon :icon="['fa', 'search']"/>
                              </span>
                    </div>
                    <b-form-input class="mr-1 ml-0 permissionSearchBar"
                                  autocomplete="off"
                                  style="padding-left: 32px; min-width: 300px; max-width: 300px;"
                                  placeholder=""
                                  :value="searchAvailablePermissionsInput"
                                  @keydown="(event) =>onKeyUp(event, 'available')"
                                  @click="assignData('whichSearchBarIsUsed', 'searchAvailablePermissions')"
                                  ref="query_v2"
                    ></b-form-input>
                    <div style="width: 0px; text-overflow: clip;">
                              <span style="position: relative; top:7px; margin-left: -24px">
                                <a href="#" @click="clearClickedAvailablePermissions" ref="clearLink"
                                   :class="statusColor" style="position: relative; top:1px"
                                   v-if="lastQuery===searchAvailablePermissionsInput && searchAvailablePermissionsInput !== ''">
                                    <font-awesome-icon :icon="['fa', 'times']" transform class="pr-2"/>
                                </a>
                              </span>
                    </div>
                  </div>
                  <div class="my-1 ml-2">
                    <span class="input-group-text">{{ numberOfAllAvailablePermissions }}</span>
                  </div>
                </div>
              </b-row>
            </b-col>
          </b-row>

          <!-- down Product-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="productPermissionsStatus"-->
            <!--                                :class="(readOnly || !productAvailableRequiredPermissions || productAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="productPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="productAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="plm-primary">Product</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-1">
                    <b-table-simple
                        :items="productAvailableRequiredPermissions"
                        ref="productPermissionsTable"
                    >
                      <div class="d-flex flex-column">
                      <b-td v-if="productAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="productPermissionsStatus"
                                  :class="(readOnly || !productAvailableRequiredPermissions || productAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="productPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="productPermissionsStatus === false">
                              Select all ({{ this.productAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.productAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                      <b-row>
<!--                        <div class="d-flex pt-1 pb-1 ml-4" style="line-height: unset">-->
<!--                          <div style="width: 0px">-->
<!--                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">-->
<!--                                  <font-awesome-icon :icon="['fa', 'search']"/>-->
<!--                              </span>-->
<!--                          </div>-->
<!--                          <b-form-input class="mr-1 ml-0"-->
<!--                                        autocomplete="off"-->
<!--                                        style="padding-left: 32px; min-width: 250px; max-width: 250px;"-->
<!--                                        placeholder=""-->
<!--                                        :value="searchAvailableProductPermissionsInput"-->
<!--                                        @keydown="(event) => handleKeyUp('product', event)"-->
<!--                                        ref="query_product"-->
<!--                          ></b-form-input>-->
<!--                          <div class="ml-2">-->
<!--                            <span class="input-group-text">{{ productAvailableRequiredPermissions.length }}</span>-->
<!--                          </div>-->
<!--                        </div>-->
                      </b-row>
                      </div>
                      <b-tr sticky-column v-for="(row, index) in productAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(productAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled=" row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Season-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="seasonPermissionsStatus"-->
            <!--                                :class="(readOnly || !seasonAvailableRequiredPermissions || seasonAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="seasonPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->

            <font-awesome-icon icon="check" v-if="seasonAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="plm-primary">Season</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-2">
                    <b-table-simple
                        :items="seasonAvailableRequiredPermissions"
                        ref="seasonPermissionsTable"
                    >
                      <div class="d-flex flex-column">
                      <b-td v-if="seasonAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="seasonPermissionsStatus"
                                  :class="(readOnly || !seasonAvailableRequiredPermissions || seasonAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="seasonPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="seasonPermissionsStatus === false">
                              Select all ({{ this.seasonAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.seasonAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                        <b-row>
<!--                      <div class="d-flex pt-1 pb-1 ml-4" style="line-height: unset">-->
<!--                        <div style="width: 0px">-->
<!--                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">-->
<!--                                  <font-awesome-icon :icon="['fa', 'search']"/>-->
<!--                              </span>-->
<!--                        </div>-->
<!--                        <b-form-input class="mr-1 ml-0"-->
<!--                                      autocomplete="off"-->
<!--                                      style="padding-left: 32px; min-width: 250px; max-width: 2500px;"-->
<!--                                      placeholder=""-->
<!--                                      :value="searchAvailableSeasonPermissionsInput"-->
<!--                                      @keydown="(event) => handleKeyUp('season', event)"-->
<!--                                      ref="query_season"-->
<!--                        ></b-form-input>-->
<!--                        <div class="ml-2">-->
<!--                          <span class="input-group-text">{{ seasonAvailableRequiredPermissions.length }}</span>-->
<!--                        </div>-->
<!--                      </div>-->
                        </b-row>
                      </div>
                      <b-tr sticky-column v-for="(row, index) in seasonAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(seasonAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Order-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="orderPermissionsStatus"-->
            <!--                                :class="(readOnly || !orderAvailableRequiredPermissions || orderAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="orderPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="orderAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="plm-primary">Order</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-3">
                    <b-table-simple
                        :items="orderAvailableRequiredPermissions"
                        ref="orderPermissionsTable"
                    >
                      <div class="d-flex flex-column">
                      <b-td v-if="orderAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="orderPermissionsStatus"
                                  :class="(readOnly || !orderAvailableRequiredPermissions || orderAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="orderPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"

                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="orderPermissionsStatus === false">
                              Select all ({{ this.orderAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.orderAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                        <b-row>
<!--                      <div class="d-flex pt-1 pb-1 ml-4" style="line-height: unset">-->
<!--                        <div style="width: 0px">-->
<!--                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">-->
<!--                                  <font-awesome-icon :icon="['fa', 'search']"/>-->
<!--                              </span>-->
<!--                        </div>-->
<!--                        <b-form-input class="mr-1 ml-0"-->
<!--                                      autocomplete="off"-->
<!--                                      style="padding-left: 32px; min-width: 250px; max-width: 2500px;"-->
<!--                                      placeholder=""-->
<!--                                      :value="searchAvailableOrderPermissionsInput"-->
<!--                                      @keydown="(event) => handleKeyUp('order', event)"-->
<!--                                      ref="query_order"-->
<!--                        ></b-form-input>-->
<!--                        <div class="ml-2">-->
<!--                          <span class="input-group-text">{{ orderAvailableRequiredPermissions.length }}</span>-->
<!--                        </div>-->
<!--                      </div>-->
                        </b-row>
                      </div>
                      <b-tr sticky-column v-for="(row, index) in orderAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(orderAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Logistics-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="logisticsPermissionsStatus"-->
            <!--                                :class="(readOnly || !logisticsAvailableRequiredPermissions || logisticsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="logisticsPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="logisticsAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="plm-primary">Logistics</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-4">
                    <b-table-simple
                        :items="logisticsAvailableRequiredPermissions"
                        ref="logisticsPermissionsTable"
                    >
                      <b-td v-if="logisticsAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="logisticsPermissionsStatus"
                                  :class="(readOnly || !logisticsAvailableRequiredPermissions || logisticsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="logisticsPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="logisticsPermissionsStatus === false">
                              Select all ({{ this.logisticsAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.logisticsAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>

                      <b-tr sticky-column v-for="(row, index) in logisticsAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(logisticsAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Budget Planner-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="budgetPlannerPermissionsStatus"-->
            <!--                                :class="(readOnly || !budgetPlannerAvailableRequiredPermissions-->
            <!--                                || budgetPlannerAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="budgetPlannerPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="budgetPlannerAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-5 variant="plm-primary">Budget Planner</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-5">
                    <b-table-simple
                        :items="budgetPlannerAvailableRequiredPermissions"
                        ref="budgetPlannerPermissionsTable"
                    >
                      <b-td v-if="budgetPlannerAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="budgetPlannerPermissionsStatus"
                                  :class="(readOnly || !budgetPlannerAvailableRequiredPermissions
                  || budgetPlannerAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="budgetPlannerPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="budgetPlannerPermissionsStatus === false">
                              Select all ({{ this.budgetPlannerAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.budgetPlannerAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>

                      <b-tr sticky-column v-for="(row, index) in budgetPlannerAvailableRequiredPermissions"
                            :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(budgetPlannerAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Dictionaries-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="dictionariesPermissionsStatus"-->
            <!--                                :class="(readOnly || !dictionariesAvailableRequiredPermissions-->
            <!--                                || dictionariesAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="dictionariesPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="dictionariesAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-6 variant="plm-primary">Dictionaries</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-6">
                    <b-table-simple
                        :items="dictionariesAvailableRequiredPermissions"
                        ref="dictionariesPermissionsTable"
                    >
                      <div class="d-flex flex-column">
                      <b-td v-if="dictionariesAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="dictionariesPermissionsStatus"
                                  :class="(readOnly || !dictionariesAvailableRequiredPermissions
                  || dictionariesAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="dictionariesPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="dictionariesPermissionsStatus === false">
                              Select all ({{ this.dictionariesAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.dictionariesAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                        <b-row>
<!--                      <div class="d-flex pt-1 pb-1 ml-4" style="line-height: unset">-->
<!--                        <div style="width: 0px">-->
<!--                              <span :class="statusColor" style="position: relative; left: 15px; top:8px">-->
<!--                                  <font-awesome-icon :icon="['fa', 'search']"/>-->
<!--                              </span>-->
<!--                        </div>-->
<!--                        <b-form-input class="mr-1 ml-0"-->
<!--                                      autocomplete="off"-->
<!--                                      style="padding-left: 32px; min-width: 250px; max-width: 250px;"-->
<!--                                      placeholder=""-->
<!--                                      :value="searchAvailableDictionaryPermissionsInput"-->
<!--                                      @keydown="(event) => handleKeyUp('dictionary', event)"-->
<!--                                      ref="query_dictionary"-->
<!--                        ></b-form-input>-->
<!--                        <div class="ml-2">-->
<!--                          <span class="input-group-text">{{ dictionariesAvailableRequiredPermissions.length }}</span>-->
<!--                        </div>-->
<!--                      </div>-->
                        </b-row>
                      </div>
                      <b-tr sticky-column v-for="(row, index) in dictionariesAvailableRequiredPermissions"
                            :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(dictionariesAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down User-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="usersPermissionsStatus"-->
            <!--                                :class="(readOnly || !usersAvailableRequiredPermissions-->
            <!--                                || usersAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="usersPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="usersAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-7 variant="plm-primary">Users</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-7">
                    <b-table-simple
                        :items="usersAvailableRequiredPermissions"
                        ref="usersPermissionsTable"
                    >
                      <b-td v-if="usersAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="usersPermissionsStatus"
                                  :class="(readOnly || !usersAvailableRequiredPermissions
                  || usersAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="usersPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="usersPermissionsStatus === false">
                              Select all ({{ this.usersAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.usersAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                      <b-tr sticky-column v-for="(row, index) in usersAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(usersAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Secured Fields-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="securedFieldsPermissionsStatus"-->
            <!--                                :class="(readOnly || !securedFieldsAvailableRequiredPermissions-->
            <!--                                || securedFieldsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="securedFieldsPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="securedFieldsAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-8 variant="plm-primary">Secured Fields</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-8">
                    <b-table-simple
                        :items="securedFieldsAvailableRequiredPermissions"
                        ref="securedFieldsPermissionsTable"
                    >
                      <b-td v-if="securedFieldsAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="securedFieldsPermissionsStatus"
                                  :class="(readOnly || !securedFieldsAvailableRequiredPermissions
                  || securedFieldsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="securedFieldsPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="securedFieldsPermissionsStatus === false">
                              Select all ({{ this.securedFieldsAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.securedFieldsAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                      <b-tr sticky-column v-for="(row, index) in securedFieldsAvailableRequiredPermissions"
                            :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(securedFieldsAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Others-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="othersPermissionsStatus"-->
            <!--                                :class="(readOnly || !othersAvailableRequiredPermissions-->
            <!--                                || othersAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="othersPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="othersAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-9 variant="plm-primary">Others</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-9">
                    <b-table-simple
                        :items="othersAvailableRequiredPermissions"
                        ref="othersPermissionsTable"
                    >
                      <b-td v-if="othersAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="othersPermissionsStatus"
                                  :class="(readOnly || !othersAvailableRequiredPermissions
                  || othersAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="othersPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="othersPermissionsStatus === false">
                              Select all ({{ this.othersAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.othersAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                      <b-tr sticky-column v-for="(row, index) in othersAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(othersAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <!-- down Reports-->
          <b-row>
            <!--            <b-col cols="1" style="margin-top: 12px;">-->
            <!--                            <b-form-checkbox-->
            <!--                                v-model="reportsPermissionsStatus"-->
            <!--                                :class="(readOnly || !reportsAvailableRequiredPermissions-->
            <!--                                || reportsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"-->
            <!--                                :disabled="reportsPermissionsDisabled"-->
            <!--                                :value="true"-->
            <!--                                :unchecked-value="false"-->
            <!--                            >-->
            <!--                            </b-form-checkbox>-->
            <!--            </b-col>-->
            <font-awesome-icon icon="check" v-if="reportsAvailableRequiredPermissions.length > 0"
                               style="color: #2a8e7f;"></font-awesome-icon>
            <font-awesome-icon icon="times" v-else style="color: #d06058;"></font-awesome-icon>
            <b-col cols="10" class="p-0" style="margin-left: 20px;">
              <div class="accordion">
                <b-card no-body>
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-10 variant="plm-primary">Reports</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-10">
                    <b-table-simple
                        :items="reportsAvailableRequiredPermissions"
                        ref="reportsPermissionsTable"
                    >
                      <b-td v-if="reportsAvailableRequiredPermissions.length > 0">
                        <b-container class="p-0" style="margin-left: 15px;">
                          <b-row no-gutters>
                            <b-col cols="1">
                              <b-form-checkbox
                                  v-model="reportsPermissionsStatus"
                                  :class="(readOnly || !reportsAvailableRequiredPermissions
                  || reportsAvailableRequiredPermissions.length === 0) ? 'd-none' : 'd-block'"
                                  :disabled="reportsPermissionsDisabled"
                                  :value="true"
                                  :unchecked-value="false"
                              >
                              </b-form-checkbox>
                            </b-col>
                            <b-col style="font-weight: bold;" v-if="reportsPermissionsStatus === false">
                              Select all ({{ this.reportsAvailableRequiredPermissions.length }})
                            </b-col>
                            <b-col style="font-weight: bold;" v-else>
                              Unselect All ({{ this.reportsAvailableRequiredPermissions.length }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-td>
                      <b-tr sticky-column v-for="(row, index) in reportsAvailableRequiredPermissions" :key="row.key">
                        <b-td>
                          <b-container>
                            <b-row no-gutters>
                              <b-col cols="1">
                                <b-form-checkbox
                                    v-if="row"
                                    @change="onSelectedAvailablePermission(reportsAvailableRequiredPermissions)"
                                    :name="'available-status-' + index"
                                    v-model="row.status"
                                    :disabled="row != null && row.disabledCheckbox"
                                    :class="readOnly ? 'd-none' : 'd-block'"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                </b-form-checkbox>
                              </b-col>
                              <b-col>
                                {{ row.label }}
                              </b-col>
                            </b-row>
                          </b-container>
                        </b-td>
                      </b-tr>
                    </b-table-simple>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import VBox from "@/components/VBox";
import Perms from "@/server/Perms";
import _ from "lodash";
import BudgetingPlanner from "@/server/com/silkplm/model/plm/BudgetingPlanner";
import FormsLoader from "@/components/forms/FormsLoader";
import Product from "@/server/com/silkplm/model/plm/Product";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import Season from "@/server/com/silkplm/model/plm/Season";
import Order from "@/server/com/silkplm/model/plm/Order";
import Users from "@/server/com/silkplm/rpc/Users";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import Dictionary from "@/server/com/silkplm/engine/model/Dictionary";
import TrancheBooking from "@/server/com/silkplm/model/plm/TrancheBooking";
import TranchePlanView from "@/server/com/silkplm/model/plm/TranchePlanView";
import TrancheBookingDetails from "@/server/com/silkplm/model/plm/TrancheBookingDetails";
import LogisticsBookingStatus from "@/server/com/silkplm/model/plm/LogisticsBookingStatus";
import LogisticsDeliveryPlan from "@/server/com/silkplm/model/plm/LogisticsDeliveryPlan";

const FORM_TYPE_PRODUCT = Product;
const FORM_TYPE_SEASON = Season;
const FORM_TYPE_ORDERS = Order;
const FORM_TYPE_TRANCHE_BOOKING = TrancheBooking;
const FORM_TYPE_TRANCHE_BOOKING_DETAILS = TrancheBookingDetails;
const FORM_TYPE_TRANCHE_PLAN_VIEW = TranchePlanView;
const FORM_TYPE_BOOKING_STATUS = LogisticsBookingStatus;
const FORM_TYPE_DELIVERY_PLAN = LogisticsDeliveryPlan;
const FORM_TYPE_BUDGETING_PLANNER = BudgetingPlanner;
const FORM_TYPE_BUDGETING_PLANNER_PM = BudgetingPlannerPM;
const FORM_TYPE_USERS = ApplicationUser;
const FORM_TYPE_DICTIONARY = Dictionary;

export default {
  name: "PermissionsEditor",

  methods: {

    setStatusToFalsAndSetCheckbox(val) {
      for (let item of this.localAssignedPermissions) {
        if (val) {
          item.status = false;
        }
        item.disabledCheckbox = val;
      }
    },

    asd(a, b, val) {
      setTimeout(() => {
        a = false;
        this.setAllInsideCheckboxOnDisabled(b, false);
      })

      for (let item of b) {
        item.status = val;
      }
    },

    setGeneralStatus(val) {
      if (val) {
        this.isListRightActive = true;
        this.isListLeftActive = false;

        this.allMainCheckboxStatus = true;
      } else {
        this.allMainCheckboxStatus = false;
      }
    },

    assignData(prop, val) {
      this[prop] = val;
    },

    searchAvailablePermissionsVisibleClick() {
      this.assignData('whichSearchBarIsUsed', 'searchAvailablePermissions');

      if (!this.searchAvailablePermissionsVisible) {
        this.searchAvailablePermissionsVisible = true;
        setTimeout(() => {
          this.$refs["query_v2"].focus();
        });
      } else {
        this.clearClickedAvailablePermissions();
        this.searchAvailablePermissionsVisible = false;
      }
    },

    searchAssignedPermissionsVisibleClick() {
      this.assignData('whichSearchBarIsUsed', 'searchAssignedPermissions');

      if (!this.searchAssignedPermissionsVisible) {
        this.searchAssignedPermissionsVisible = true;
        setTimeout(() => {
          this.$refs["query_v1"].focus();
        });
      } else {
        this.clearClickedAssignedPermissions();
        this.searchAssignedPermissionsVisible = false;
      }
    },

    onKeyUp(ev, target) {
      let key = ev.keyCode || ev.charCode;
      if (key == 8 || key == 46) {
        this.searchChanged("Backspace");
      }
      else if (key == 27) {
        if(target === 'assigned') {
          this.searchAssignedPermissionsInput = ev.target.value.trim();
        }
        else if (target === 'available') {
          this.searchAvailablePermissionsInput = ev.target.value.trim();
        }
        this.searchChanged("Escape");
      }
      else if (key == 13) {
        if(target === 'assigned') {
          this.searchAssignedPermissionsInput = ev.target.value.trim();
        }
        else if (target === 'available') {
          this.searchAvailablePermissionsInput = ev.target.value.trim();
        }
        this.searchChanged("Enter");
      }
      else if (key == 46) {
        if(target === 'assigned') {
          this.searchAssignedPermissionsInput = ev.target.value.trim();
        }
        else if (target === 'available') {
          this.searchAvailablePermissionsInput = ev.target.value.trim();
        }
        this.searchChanged("Del");
      }
    },

    handleKeyUp(type,event) {
      const key = event.key;
      if (key !== "Enter" && key !== "Escape") {
        return;
      }

      const isProduct = type === "product";
      const isSeason = type === "season";
      const isOrder = type === "order";
      const isDictionary = type === "dictionary"

      if (key === "Enter") {
        const inputValue = event.target.value.trim();
        if (isProduct) {
          this.searchAvailableProductPermissionsInput = inputValue;

          if (inputValue === "") {
            this.productAvailableRequiredPermissions = [...this.allProductAvailableRequiredPermissions];
          } else {
            this.productAvailableRequiredPermissions = this.allProductAvailableRequiredPermissions.filter(
                (element) => element.label.includes(inputValue)
            );
          }
        } else if (isSeason) {
          this.searchAvailableSeasonPermissionsInput = inputValue;

          if (inputValue === "") {
            this.seasonAvailableRequiredPermissions = [...this.allSeasonAvailableRequiredPermissions];
          } else {
            this.seasonAvailableRequiredPermissions = this.allSeasonAvailableRequiredPermissions.filter(
                (element) => element.label.includes(inputValue)
            );
          }
        }
        else if (isOrder) {
          this.searchAvailableOrderPermissionsInput = inputValue;

          if (inputValue === "") {
            this.orderAvailableRequiredPermissions = [...this.allOrderAvailableRequiredPermissions];
          } else {
            this.orderAvailableRequiredPermissions = this.allOrderAvailableRequiredPermissions.filter(
                (element) => element.label.includes(inputValue)
            );
          }
        }
        else if (isDictionary) {
          this.searchAvailableDictionaryPermissionsInput = inputValue;

          if (inputValue === "") {
            this.dictionariesAvailableRequiredPermissions = [...this.allDictionaryAvailableRequiredPermissions];
          } else {
            this.dictionariesAvailableRequiredPermissions = this.allDictionaryAvailableRequiredPermissions.filter(
                (element) => element.label.includes(inputValue)
            );
          }
        }
      } else if (key === "Escape") {
        if (isProduct) {
          this.searchAvailableProductPermissionsInput = "";
          this.productAvailableRequiredPermissions = [...this.allProductAvailableRequiredPermissions];
          this.$refs["query_product"].focus();
        } else if (isSeason) {
          this.searchAvailableSeasonPermissionsInput = "";
          this.seasonAvailableRequiredPermissions = [...this.allSeasonAvailableRequiredPermissions];
          this.$refs["query_season"].focus();
        }
        else if (isOrder) {
          this.searchAvailableOrderPermissionsInput = "";
          this.orderAvailableRequiredPermissions = [...this.allOrderAvailableRequiredPermissions];
          this.$refs["query_order"].focus();
        }
        else if (isDictionary) {
          this.searchAvailableDictionaryPermissionsInput = "";
          this.dictionariesAvailableRequiredPermissions = [...this.allDictionaryAvailableRequiredPermissions];
          this.$refs["query_dictionary"].focus();
        }
      }
    },

    searchChanged(key) {
      if (key == "Enter") {
        this.searchClicked();
        return false;
      }
      if (key == "Escape") {
        if (this.searchAvailablePermissionsVisible) {
          this.loadAvailablePermissionsForFormMode = "None";
          this.clearClickedAvailablePermissions();
        }
        if (this.searchAssignedPermissionsVisible) {
          this.loadAssignedPermissionsForFormMode = "None";
          this.clearClickedAssignedPermissions();
        }
        return false;
      }

      if (this.pendingTimer) {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }

      this.pendingTimer = setTimeout(() => {
        if (this.whichSearchBarIsUsed === "searchAvailablePermissions")
          this.executeAvailablePermissionsQuery();
        else if (this.whichSearchBarIsUsed === "searchAssignedPermissions") {
          this.loadAssignedPermissionsForFormMode = "searchBar";
          this.executeAssignedPermissionsQuery();
        }
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }, 1000);
    },

    searchClicked() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      if (this.whichSearchBarIsUsed === "searchAvailablePermissions") {
        this.executeAvailablePermissionsQuery();
        this.$refs["query_v2"].focus();
      } else if (this.whichSearchBarIsUsed === "searchAssignedPermissions") {
        if (this.searchAssignedPermissionsInput) {
          let value = this.searchAssignedPermissionsInput.trim().toLowerCase();
          this.filteredlocalAssignedPermissions = this.localAssignedPermissions.filter(element => {
            const labelToCheck = element.customLabel ? element.customLabel.toLowerCase() : element.label.toLowerCase();
            return labelToCheck.includes(value);
          });
          this.filteredlocalAssignedPermissions.map(element=> {
            element.__visible__ = true;
            return element;
          })
        }
        else {
          this.filteredlocalAssignedPermissions = this.localAssignedPermissions;
        }
        this.$refs["query_v1"].focus();
      }
    },

    executeAvailablePermissionsQuery: function () {
      if (!this.searchAvailablePermissionsInput) {
        this.statusColor = "text-secondary";
      } else {
        this.statusColor = "text-success";

      }
      this.loadAvailablePermissionsForFormMode = "searchBar";
      this.clearAllAvailableRequiredPermissions();
      this.loadAvailablePermissionsForAllForms();

      this.countAvailablePermissions();
    },

    executeAssignedPermissionsQuery: function () {
      if (!this.searchAssignedPermissionsInput) {
        this.statusColor = "text-secondary";
      } else {
        this.statusColor = "text-success";
      }
      this.loadLocalAssignedPermissions();

      this.countAssignedPermissions()
    },

    clearClickedAvailablePermissions() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      if (this.searchAvailablePermissionsVisible) {
        this.searchAvailablePermissionsInput = "";
      }
      this.executeAvailablePermissionsQuery();
      this.$refs["query_v2"].focus();
    },

    clearClickedAssignedPermissions() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      if (this.searchAssignedPermissionsVisible) {
        this.searchAssignedPermissionsInput = "";
      }
      this.executeAssignedPermissionsQuery();
      this.filteredlocalAssignedPermissions = this.localAssignedPermissions;
      this.$refs["query_v1"].focus();
    },

    countAssignedPermissions() {
      this.numberOfAssignedPermissions = 0;
      for (let i of this.localAssignedPermissions)
        if (i.__visible__ == true)
          this.numberOfAssignedPermissions += 1;
    },

    changeModel() {
      this.$emit('model-change', this.localAssignedPermissions);
    },

    createCustomLabelToAssignedPermissions() {
      for (let perm of this.localAssignedPermissions) {
        this.assignCustomLabelToPerm(perm);
      }
    },

    assignCustomLabelToPerm(perm) {
      if (!perm) {
        console.log("perm empty");
      }
      if (perm.label?.length) {
        perm.customLabel = perm.label + " (";
        if (_.find(this.productRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Product/";
        }
        if (_.find(this.seasonRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Season/";
        }
        if (_.find(this.orderRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Order/";
        }
        if (_.find(this.logisticsRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Logistics/";
        }
        if (_.find(this.budgetPlannerRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Budget Planner/";
        }
        if (_.find(this.dictionariesRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Dictionaries/";
        }
        if (_.find(this.usersRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Users/";
        }
        if (_.find(this.securedFieldsRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Secured Fields/";
        }
        if (_.find(this.reportsRequiredPermissions, {'code': perm.code})) {
          perm.customLabel += "Reports/";
        } else {
          if (_.find(this.othersRequiredPermissions, {'code': perm.code})) {
            perm.customLabel += "Others/";
          }
        }
        perm.customLabel = perm.customLabel.slice(0, perm.customLabel.length - 1);
        perm.customLabel += ")";
      }
    },

    collectPermissionsWhichHaveALocatedPlace() {
      this.findUniquePermissionListWhichHasPlace(this.productRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.seasonRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.orderRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.logisticsRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.budgetPlannerRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.dictionariesRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.usersRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.securedFieldsRequiredPermissions);
      this.findUniquePermissionListWhichHasPlace(this.reportsRequiredPermissions);
    },

    sortPermissions() {
      this.productRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.productAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.seasonRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.seasonAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.orderRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.orderAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.logisticsRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.logisticsAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.dictionariesRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.dictionariesAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.usersRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.usersAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.securedFieldsRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.securedFieldsAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.budgetPlannerRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.budgetPlannerAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.othersRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.othersAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.reportsRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.reportsAvailableRequiredPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
      this.localAssignedPermissions.sort((a, b) => (a.label > b.label) ? 1 : -1);
    },

    async loadAllRequiredPermissions() {
      let mapFormNameWithListOfDynamicPermissions = await Rpc.Roles.findRequiredPermissionsForModule();
      this.productRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.productFormConfig.formClassLong];
      this.seasonRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.seasonFormConfig.formClassLong];
      this.orderRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.orderFormConfig.formClassLong];
      this.dictionariesRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.dictionaryFormConfig.formClassLong];
      this.usersRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.userFormConfig.formClassLong];
      this.securedFieldsRequiredPermissions = mapFormNameWithListOfDynamicPermissions["secured_fields"];
      this.reportsRequiredPermissions = mapFormNameWithListOfDynamicPermissions["reports"];
      this.loadRequiredPermissionForBudgetingPlanner(mapFormNameWithListOfDynamicPermissions);
      this.loadRequiredPermissionForLogistics(mapFormNameWithListOfDynamicPermissions);
      this.sortPermissions()
    },

    loadRequiredPermissionForBudgetingPlanner(mapFormNameWithListOfDynamicPermissions) {
      this.budgetPlannerRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.budgetingPlannerPMFormConfig.formClassLong];
      let budgetingPlannerPermissions = mapFormNameWithListOfDynamicPermissions[this.budgetingPlannerFormConfig.formClassLong];
      for (let perm of budgetingPlannerPermissions) {
        let foundPermissionInBudgetingPlanner = _.find(this.budgetPlannerRequiredPermissions, {'code': perm.code});
        if (!foundPermissionInBudgetingPlanner) {
          this.budgetPlannerRequiredPermissions.push(perm);
        }
      }
    },

    loadRequiredPermissionForLogistics(mapFormNameWithListOfDynamicPermissions) {
      this.logisticsRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.trancheBookingFormConfig.formClassLong];
      let logisticsBookingDetailsRequiredPermissions = mapFormNameWithListOfDynamicPermissions[this.trancheBookingDetailsFormConfig.formClassLong];
      let tranchePlanViewPermissions = mapFormNameWithListOfDynamicPermissions[this.tranchePlanViewFormConfig.formClassLong];
      let bookingStatusPermissions = mapFormNameWithListOfDynamicPermissions[this.bookingStatusFormConfig.formClassLong];
      let deliveryPlanPermissions = mapFormNameWithListOfDynamicPermissions[this.deliveryPlanFormConfig.formClassLong];
      this.addPermissionsToLogisticRequiredPermissions(tranchePlanViewPermissions);
      this.addPermissionsToLogisticRequiredPermissions(logisticsBookingDetailsRequiredPermissions);
      this.addPermissionsToLogisticRequiredPermissions(logisticsBookingDetailsRequiredPermissions);
      this.addPermissionsToLogisticRequiredPermissions(bookingStatusPermissions);
      this.addPermissionsToLogisticRequiredPermissions(deliveryPlanPermissions);
    },

    addPermissionsToLogisticRequiredPermissions(modulePerms) {
      for (let perm of modulePerms) {
        let foundPermissionInLogisticsRequiredPermissions = _.find(this.logisticsRequiredPermissions, {'code': perm.code});
        if (!foundPermissionInLogisticsRequiredPermissions) {
          this.logisticsRequiredPermissions.push(perm);
        }
      }
    },

    loadAvailablePermissionsForAllForms() {
      this.loadAvailablePermissionsForForm(this.productRequiredPermissions, this.productAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.seasonRequiredPermissions, this.seasonAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.orderRequiredPermissions, this.orderAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.logisticsRequiredPermissions, this.logisticsAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.budgetPlannerRequiredPermissions, this.budgetPlannerAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.dictionariesRequiredPermissions, this.dictionariesAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.usersRequiredPermissions, this.usersAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.securedFieldsRequiredPermissions, this.securedFieldsAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.othersRequiredPermissions, this.othersAvailableRequiredPermissions);
      this.loadAvailablePermissionsForForm(this.reportsRequiredPermissions, this.reportsAvailableRequiredPermissions);
    },

    loadAvailablePermissionsForForm(requiredPermissionList, availableRequiredPermissionList) {
      for (let requiredPermission of requiredPermissionList) {
        let foundPermissionInOrder = _.find(this.assignedPermissions, {'code': requiredPermission.code});
        if (this.loadAvailablePermissionsForFormMode === "None" && !foundPermissionInOrder) {
          availableRequiredPermissionList.push(requiredPermission);
        } else if (this.loadAvailablePermissionsForFormMode === "searchBar") {
          if (this.findPhraseInSearchBar(this.searchAvailablePermissionsInput.toLowerCase(), requiredPermission.label.toLowerCase())) {
            availableRequiredPermissionList.push(requiredPermission);
          }
        }

        for (let perm of this.localAssignedPermissions) {
          let foundPermissionInProductsIndex = _.findIndex(availableRequiredPermissionList, {'code': perm.code});
          if (foundPermissionInProductsIndex !== -1) {
            availableRequiredPermissionList.splice(foundPermissionInProductsIndex, 1);
          }
        }
      }
    },

    countAvailablePermissions() {
      this.numberOfAllAvailablePermissions =
          this.productAvailableRequiredPermissions.length +
          this.seasonAvailableRequiredPermissions.length +
          this.orderAvailableRequiredPermissions.length +
          this.logisticsAvailableRequiredPermissions.length +
          this.budgetPlannerAvailableRequiredPermissions.length +
          this.dictionariesAvailableRequiredPermissions.length +
          this.usersAvailableRequiredPermissions.length +
          this.securedFieldsAvailableRequiredPermissions.length +
          this.othersAvailableRequiredPermissions.length;
      this.reportsAvailableRequiredPermissions.length;
    },

    clearAllAvailableRequiredPermissions() {
      this.productAvailableRequiredPermissions = [];
      this.seasonAvailableRequiredPermissions = [];
      this.orderAvailableRequiredPermissions = [];
      this.logisticsAvailableRequiredPermissions = [];
      this.budgetPlannerAvailableRequiredPermissions = [];
      this.dictionariesAvailableRequiredPermissions = [];
      this.usersAvailableRequiredPermissions = [];
      this.securedFieldsAvailableRequiredPermissions = [];
      this.othersAvailableRequiredPermissions = [];
      this.reportsAvailableRequiredPermissions = [];
    },

    findPhraseInSearchBar(testPhrase, phrase) {
      return !!phrase.includes(testPhrase);
    },

    async collectOthersRequiredPermissions() {
      let othersPermissions = [];
      for (let perm of this.allPerms) {
        let foundPermission = _.find(this.allPermissionsWhichHaveALocatedPlace, {'code': perm.code});
        if (!foundPermission) {
          othersPermissions.push(perm);
        }
      }
      let listOfCodes = [];
      let listOfOtherPerms = [];
      for (let perm of othersPermissions) {
        if (perm.name.startsWith("DASH")) {
          this.othersRequiredPermissions.push(perm);
        }
        if (!perm.name.startsWith("REPORT") && perm.name !== "ALL_REPORT") {
          listOfCodes.push(perm.code);
          listOfOtherPerms.push(perm);
        } else {
          this.reportsRequiredPermissions.push(perm);
        }
      }
      let listOfFormConfigs = await Rpc.Roles.findFormConfigsByListOfPermissionCode(listOfCodes).lock();

      listOfOtherPerms.forEach(value => {
        let formConfig = null;
        formConfig = _.find(listOfFormConfigs, {'effectivePermissionRead': value.name});
        if (!formConfig) {
          formConfig = _.find(listOfFormConfigs, {'effectivePermissionWrite': value.name});
        }
        if (!formConfig) {
          formConfig = _.find(listOfFormConfigs, {'effectivePermissionList': value.name});
        }
        if (!formConfig) {
          this.othersRequiredPermissions.push(value);
        } else {
          if (formConfig.devOnly) {
            return;
          }
          if (formConfig.menuGroup && formConfig.menuGroup.startsWith('forms-test')) {
            return;
          }
          this.othersRequiredPermissions.push(value);
        }
      })
    },

    findUniquePermissionListWhichHasPlace(permissionList) {
      for (let perm of permissionList) {
        let foundPermission = _.find(this.allPermissionsWhichHaveALocatedPlace, {'code': perm.code});
        if (!foundPermission) {
          this.allPermissionsWhichHaveALocatedPlace.push(perm);
        }
      }
    },

    onSelectedAssignedPermission() {
      // activate watch
      // TODO zweryfikować co to robi?????????????
      // let tempList = this.orderAvailableRequiredPermissions;
      // this.orderAvailableRequiredPermissions = [];
      // this.orderAvailableRequiredPermissions = tempList;
      let anyItemSelected = false;
      anyItemSelected = this.filteredlocalAssignedPermissions.some(item => item.status);
      if (anyItemSelected) {
        this.isListLeftActive = true;
        this.isListRightActive = false;
        this.productPermissionsDisabled = true;
        this.seasonPermissionsDisabled = true;
        this.orderPermissionsDisabled = true;
        this.logisticsPermissionsDisabled = true;
        this.budgetPlannerPermissionsDisabled = true;
        this.dictionariesPermissionsDisabled = true;
        this.usersPermissionsDisabled = true;
        this.securedFieldsPermissionsDisabled = true;
        this.othersPermissionsDisabled = true;
        this.reportsPermissionsDisabled = true;

      } else {
        this.setAllOutsideCheckboxOnDisabled();
      }
      this.setStatusAndCheckbox(this.productAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.seasonAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.orderAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.logisticsAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.budgetPlannerAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.dictionariesAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.usersAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.securedFieldsAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.othersAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.reportsAvailableRequiredPermissions, anyItemSelected);

    },

    changeAllAssignedPermissionsCheckbox(newStatus) {
      for (let item of this.filteredlocalAssignedPermissions) {
        item.status = newStatus;
        item.disabledCheckbox = false;
      }
      this.onSelectedAssignedPermission();
      this.localAssignedPermissionsStatus = newStatus;
      this.$forceUpdate()
    },


    onSelectedAvailablePermission(list) {
      // TODO zweryfikować co to robi?????????????
      // Było tylko dla wywołania watch'a - teraz dla jednej listy sprawdza
      // let tempList = this.localAssignedPermissions;
      // this.localAssignedPermissions = [];
      // this.localAssignedPermissions = tempList;
      let anyItemSelected = false;
      this.checkList = this.checkIfAnyItemSelected(list);
      if (this.checkList) {
        anyItemSelected = true;
      }
      if (anyItemSelected) {
        this.isListLeftActive = false;
        this.isListRightActive = true;
      }
      this.setStatusAndCheckbox(this.localAssignedPermissions, anyItemSelected);
      this.changeModel();
    },

    async moveItem() {
      if (this.isListRightActive) {
        let type = null;
        if (this.productPermissionsStatus) {
          type = "Product";
        } else if (this.seasonPermissionsStatus) {
          type = "Season";
        } else if (this.orderPermissionsStatus) {
          type = "Order";
        } else if (this.logisticsPermissionsStatus) {
          type = "Order";
        } else if (this.budgetPlannerPermissionsStatus) {
          type = "Budget Planner";
        } else if (this.dictionariesPermissionsStatus) {
          type = "Dictionaries";
        } else if (this.usersPermissionsStatus) {
          type = "Users";
        } else if (this.securedFieldsPermissionsStatus) {
          type = "Secured Fields";
        } else if (this.othersPermissionsStatus) {
          type = "Others";
        } else if (this.reportsPermissionsStatus) {
          type = "Reports";
        }
        if (type) {
          if (await DialogManager.yesNo("Move all permissions from " + type,
              "Are you sure you want to move all permissions from " + type + "?")) {
            this.moveItemFromRightToLeft();
            switch (type) {
              case "Product" :
                this.productPermissionsStatus = false;
                break;
              case "Season" :
                this.seasonPermissionsStatus = false;
                break;
              case "Order" :
                this.orderPermissionsStatus = false;
                break;
              case "Logistics" :
                this.logisticsPermissionsStatus = false;
                break;
              case "Budget Planner" :
                this.budgetPlannerPermissionsStatus = false;
                break;
              case "Dictionaries" :
                this.dictionariesPermissionsStatus = false;
                break;
              case "Users" :
                this.usersPermissionsStatus = false;
                break;
              case "Secured Fields" :
                this.securedFieldsPermissionsStatus = false;
                break;
              case "Others" :
                this.othersPermissionsStatus = false;
                break;
              case "Reports" :
                this.reportsPermissionsStatus = false;
                break;
            }
          }
        } else {
          this.moveItemFromRightToLeft();
        }
      } else {
        this.moveItemFromLeftToRight();
      }
      this.isListRightActive = false;
      this.isListLeftActive = false;
    },


    moveItemFromRightToLeft() {
      this.movePermissionsFromAvailableToAssigned(this.allProductAvailableRequiredPermissions, "Product");
      this.searchAvailableProductPermissionsInput = "";
      this.productAvailableRequiredPermissions = [...this.allProductAvailableRequiredPermissions];
      this.movePermissionsFromAvailableToAssigned(this.allSeasonAvailableRequiredPermissions, "Season");
      this.searchAvailableSeasonPermissionsInput = "";
      this.seasonAvailableRequiredPermissions = [...this.allSeasonAvailableRequiredPermissions];
      this.movePermissionsFromAvailableToAssigned(this.allOrderAvailableRequiredPermissions, "Order");
      this.searchAvailableOrderPermissionsInput = "";
      this.orderAvailableRequiredPermissions = [...this.allOrderAvailableRequiredPermissions];
      this.movePermissionsFromAvailableToAssigned(this.logisticsAvailableRequiredPermissions, "Logistics");
      this.movePermissionsFromAvailableToAssigned(this.budgetPlannerAvailableRequiredPermissions, "Budget Planner");
      this.movePermissionsFromAvailableToAssigned(this.allDictionaryAvailableRequiredPermissions, "Dictionaries");
      this.searchAvailableDictionaryPermissionsInput = "";
      this.dictionariesAvailableRequiredPermissions = [...this.allDictionaryAvailableRequiredPermissions];
      this.movePermissionsFromAvailableToAssigned(this.usersAvailableRequiredPermissions, "Users");
      this.movePermissionsFromAvailableToAssigned(this.securedFieldsAvailableRequiredPermissions, "Secured Fields");
      this.movePermissionsFromAvailableToAssigned(this.othersAvailableRequiredPermissions, "Others");
      this.movePermissionsFromAvailableToAssigned(this.reportsAvailableRequiredPermissions, "Reports");
      this.createCustomLabelToAssignedPermissions();
      this.sortPermissions();
      this.loadAssignedPermissionsForFormMode = "searchBar";
      this.loadLocalAssignedPermissions();
      this.countAvailablePermissions();
      this.countAssignedPermissions();
      this.$forceUpdate()
    },

    movePermissionsFromAvailableToAssigned(listOfAvailablePermission) {
      for (let item of listOfAvailablePermission) {
        if (item.status) {
          item.status = false;
          let foundPermissionInAssignedPermissions = _.find(this.localAssignedPermissions, {'code': item.code});
          if (!foundPermissionInAssignedPermissions) {
            this.assignCustomLabelToPerm(item);
            this.localAssignedPermissions.push(item);
          } else {
            foundPermissionInAssignedPermissions.disabledCheckbox = false;
          }
        }
      }

      for (let perm of this.localAssignedPermissions) {
        let foundPermissionInProductsIndex = _.findIndex(listOfAvailablePermission, {'code': perm.code});
        if (foundPermissionInProductsIndex !== -1) {
          listOfAvailablePermission.splice(foundPermissionInProductsIndex, 1);
        }
      }
    },

    moveItemFromLeftToRight() {
      let newAssignedPermissionList = [];
      for (let item of this.localAssignedPermissions) {
        let anyListIncludePermission = false;
        if (item.status) {
          let foundPermissionInProducts = _.find(this.productRequiredPermissions, {'code': item.code});
          if (foundPermissionInProducts) {
            this.productAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInSeasons = _.find(this.seasonRequiredPermissions, {'code': item.code});
          if (foundPermissionInSeasons) {
            this.seasonAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInOrders = _.find(this.orderRequiredPermissions, {'code': item.code});
          if (foundPermissionInOrders) {
            this.orderAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInLogistics = _.find(this.logisticsRequiredPermissions, {'code': item.code});
          if (foundPermissionInLogistics) {
            this.logisticsAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInBudgetingPlanner = _.find(this.budgetPlannerRequiredPermissions, {'code': item.code});
          if (foundPermissionInBudgetingPlanner) {
            this.budgetPlannerAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInDictionaries = _.find(this.dictionariesRequiredPermissions, {'code': item.code});
          if (foundPermissionInDictionaries) {
            this.dictionariesAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInUsers = _.find(this.usersRequiredPermissions, {'code': item.code});
          if (foundPermissionInUsers) {
            this.usersAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInSecuredFields = _.find(this.securedFieldsRequiredPermissions, {'code': item.code});
          if (foundPermissionInSecuredFields) {
            this.securedFieldsAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          let foundPermissionInReports = _.find(this.reportsRequiredPermissions, {'code': item.code});
          if (foundPermissionInReports) {
            this.reportsAvailableRequiredPermissions.unshift(item);
            anyListIncludePermission = true;
          }
          if (!anyListIncludePermission) {
            this.othersAvailableRequiredPermissions.unshift(item);
          }
          item.status = false;
        } else {
          newAssignedPermissionList.push(item);
        }
      }
      this.localAssignedPermissions = newAssignedPermissionList;
      this.filteredlocalAssignedPermissions = newAssignedPermissionList;
      this.searchAssignedPermissionsInput = "";
      this.setAllInsideCheckboxOnDisabledAllForm(false);
      this.setAllOutsideCheckboxOnDisabled();
      this.sortPermissions();
      this.loadAssignedPermissionsForFormMode = "searchBar";
      this.loadLocalAssignedPermissions();
      this.countAvailablePermissions();
      this.countAssignedPermissions();

      this.localAssignedPermissionsStatus = false;
      this.isChecked = false;
      this.$forceUpdate()

    },

    loadLocalAssignedPermissions() {
      if (this.loadAssignedPermissionsForFormMode === "None") {
        for (let i of this.localAssignedPermissions) {
          i.__visible__ = true;
        }
      } else if (this.loadAssignedPermissionsForFormMode === "searchBar") {
        for (let Permission of this.localAssignedPermissions) {
          Permission.__visible__ = false;
          if (this.findPhraseInSearchBar(this.searchAssignedPermissionsInput.toLowerCase(), Permission.label.toLowerCase())) {
            Permission.__visible__ = true;
          }
        }
      }
      this.$forceUpdate()
    },

    setAllInsideCheckboxOnDisabledAllForm(val) {
      this.setAllInsideCheckboxOnDisabled(this.productAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.seasonAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.orderAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.logisticsAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.budgetPlannerAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.dictionariesAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.usersAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.securedFieldsAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.othersAvailableRequiredPermissions, val);
      this.setAllInsideCheckboxOnDisabled(this.reportsAvailableRequiredPermissions, val);
      this.$forceUpdate()
    },

    checkIfAnyItemSelected(listOfAvailablePermission) {
      return listOfAvailablePermission.some(obiekt => obiekt.status);
    },

    setStatusAndCheckbox(list, anyItemSelected) {
      list.forEach(item => {
        if (anyItemSelected) {
          item.status = false;
        }
        item.disabledCheckbox = anyItemSelected;
      });
      this.$forceUpdate()
    },

    setAllInsideCheckboxOnDisabled(list, val) {
      for (let item of list) {
        item.disabledCheckbox = val;
      }
    },

    setAllOutsideCheckboxOnDisabled() {
      this.productPermissionsDisabled = false;
      this.seasonPermissionsDisabled = false;
      this.orderPermissionsDisabled = false;
      this.logisticsPermissionsDisabled = false;
      this.budgetPlannerPermissionsDisabled = false;
      this.dictionariesPermissionsDisabled = false;
      this.usersPermissionsDisabled = false;
      this.securedFieldsPermissionsDisabled = false;
      this.othersPermissionsDisabled = false;
      this.reportsPermissionsDisabled = false;
    }
  },

  components: {VBox},

  async created() {

    for (const k in Perms) {
      this.allPerms.push(Perms[k]);
    }

    await this.loadAllRequiredPermissions();
    this.collectPermissionsWhichHaveALocatedPlace();
    await this.collectOthersRequiredPermissions();
    this.createCustomLabelToAssignedPermissions();
    this.loadAvailablePermissionsForAllForms();
    this.sortPermissions();
    this.countAvailablePermissions();
    this.countAssignedPermissions();
    this.allProductAvailableRequiredPermissions = this.productAvailableRequiredPermissions;
    this.allSeasonAvailableRequiredPermissions = this.seasonAvailableRequiredPermissions;
    this.allOrderAvailableRequiredPermissions = this.orderAvailableRequiredPermissions;
    this.allDictionaryAvailableRequiredPermissions = this.dictionariesAvailableRequiredPermissions;
    this.filteredlocalAssignedPermissions = this.localAssignedPermissions;
  },


  model: {
    prop: 'assignedPermissions',
    event: 'model-change',
  },

  props: {
    showSearch: {type: Boolean, default: true},
    searchBarClass: {type: String, default: ""},


    readOnly: {type: Boolean, default: true},
    assignedPermissions: {type: Array, default: []},
  },

  watch: {

    checkList: function (val, oldVal) {
      for (let item of this.localAssignedPermissions) {
        item.disabledCheckbox = val;
      }
    },

    assignedPermissions: function (val) {
      if (this.loadAssignedPermissionsForFormMode == "None") {
        for (let i of val)
          i.__visible__ = true;
      }
      this.localAssignedPermissions = val;
    },

    allMainCheckboxStatus: function (val) {
      this.productPermissionsDisabled = val;
      this.seasonPermissionsDisabled = val;
      this.orderPermissionsDisabled = val;
      this.logisticsPermissionsDisabled = val;
      this.budgetPlannerPermissionsDisabled = val;
      this.dictionariesPermissionsDisabled = val;
      this.usersPermissionsDisabled = val;
      this.securedFieldsPermissionsDisabled = val;
      this.othersPermissionsDisabled = val;
      this.reportsPermissionsDisabled = val;
      this.setAllInsideCheckboxOnDisabledAllForm(val);
    },

    readOnly: function (val) {
      if (!val) {
        for (let el of this.localAssignedPermissions) {
          el.status = false;
        }
      }
    },

    productPermissionsStatus: function (val) {

      // this.asd(this.productPermissionsDisabled, this.productAvailableRequiredPermissions, val)
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.productPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.productAvailableRequiredPermissions, false);
      })

      for (let item of this.productAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox(val);
    },

    seasonPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.seasonPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.seasonAvailableRequiredPermissions, false);
      })

      for (let item of this.seasonAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    orderPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.orderPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.orderAvailableRequiredPermissions, false);
      })

      for (let item of this.orderAvailableRequiredPermissions) {
        item.status = val;
      }

      for (let item of this.localAssignedPermissions) {
        if (val) {
          item.status = false;
          item.status = false;
        }
        item.disabledCheckbox = val;
      }
    },

    logisticsPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.logisticsPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.logisticsAvailableRequiredPermissions, false);
      })

      for (let item of this.logisticsAvailableRequiredPermissions) {
        item.status = val;
      }

      for (let item of this.localAssignedPermissions) {
        if (val) {
          item.status = false;
          item.status = false;
        }
        item.disabledCheckbox = val;
      }
    },

    budgetPlannerPermissionsStatus: function (val) {
      if (val) {
        this.isListRightActive = true;
        this.isListLeftActive = false;

        this.allMainCheckboxStatus = true;

      } else {
        this.allMainCheckboxStatus = false;
      }

      setTimeout(() => {
        this.budgetPlannerPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.budgetPlannerAvailableRequiredPermissions, false);
      })

      for (let item of this.budgetPlannerAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    dictionariesPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.dictionariesPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.dictionariesAvailableRequiredPermissions, false);
      })

      for (let item of this.dictionariesAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    usersPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.usersPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.usersAvailableRequiredPermissions, false);
      })

      for (let item of this.usersAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    securedFieldsPermissionsStatus: function (val) {
      this.setGeneralStatus(val);

      setTimeout(() => {
        this.securedFieldsPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.securedFieldsAvailableRequiredPermissions, false);
      })

      for (let item of this.securedFieldsAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    othersPermissionsStatus: function (val) {

      this.setGeneralStatus(val);

      setTimeout(() => {
        this.othersPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.othersAvailableRequiredPermissions, false);
      })

      for (let item of this.othersAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    reportsPermissionsStatus: function (val) {

      this.setGeneralStatus(val);

      setTimeout(() => {
        this.reportsPermissionsDisabled = false;
        this.setAllInsideCheckboxOnDisabled(this.reportsAvailableRequiredPermissions, false);
      })

      for (let item of this.reportsAvailableRequiredPermissions) {
        item.status = val;
      }

      this.setStatusToFalsAndSetCheckbox();
    },

    orderAvailableRequiredPermissions: function (val) {
      let anyItemSelected = false;
      anyItemSelected = this.localAssignedPermissions.some(item => item.status);
      if (anyItemSelected) {
        this.isListLeftActive = true;
        this.isListRightActive = false;
        this.productPermissionsDisabled = true;
        this.seasonPermissionsDisabled = true;
        this.orderPermissionsDisabled = true;
        this.logisticsPermissionsDisabled = true;
        this.budgetPlannerPermissionsDisabled = true;
        this.dictionariesPermissionsDisabled = true;
        this.usersPermissionsDisabled = true;
        this.securedFieldsPermissionsDisabled = true;
        this.othersPermissionsDisabled = true;
        this.reportsPermissionsDisabled = true;

      } else {
        this.setAllOutsideCheckboxOnDisabled();
      }
      this.setStatusAndCheckbox(this.productAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.seasonAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.orderAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.logisticsAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.budgetPlannerAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.dictionariesAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.usersAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.securedFieldsAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.othersAvailableRequiredPermissions, anyItemSelected);
      this.setStatusAndCheckbox(this.reportsAvailableRequiredPermissions, anyItemSelected);
    },

    localAssignedPermissions: function (newVal) {
      let anyItemSelected = false;
      let productAnyItemSelected = this.checkIfAnyItemSelected(this.productAvailableRequiredPermissions);
      let seasonAnyItemSelected = this.checkIfAnyItemSelected(this.seasonAvailableRequiredPermissions);
      let orderAnyItemSelected = this.checkIfAnyItemSelected(this.orderAvailableRequiredPermissions);
      let logisticsAnyItemSelected = this.checkIfAnyItemSelected(this.logisticsAvailableRequiredPermissions);
      let budgetPlannerAnyItemSelected = this.checkIfAnyItemSelected(this.budgetPlannerAvailableRequiredPermissions);
      let dictionariesAnyItemSelected = this.checkIfAnyItemSelected(this.dictionariesAvailableRequiredPermissions);
      let usersItemSelected = this.checkIfAnyItemSelected(this.usersAvailableRequiredPermissions);
      let securedFieldItemSelected = this.checkIfAnyItemSelected(this.securedFieldsAvailableRequiredPermissions);
      let othersAnyItemSelected = this.checkIfAnyItemSelected(this.othersAvailableRequiredPermissions);
      let reportsAnyItemSelected = this.checkIfAnyItemSelected(this.reportsAvailableRequiredPermissions);

      if (productAnyItemSelected || seasonAnyItemSelected || orderAnyItemSelected || logisticsAnyItemSelected ||
          budgetPlannerAnyItemSelected || dictionariesAnyItemSelected || usersItemSelected ||
          securedFieldItemSelected || othersAnyItemSelected || reportsAnyItemSelected) {
        anyItemSelected = true;
      }

      if (anyItemSelected) {
        this.isListLeftActive = false;
        this.isListRightActive = true;
      }
      for (let item of this.localAssignedPermissions) {
        if (anyItemSelected) {
          item.status = false;
        }
        item.disabledCheckbox = anyItemSelected;
      }
      this.changeModel();
    },
  },

  data: () => ({
    productFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_PRODUCT),
    seasonFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_SEASON),
    orderFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_ORDERS),
    trancheBookingFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_TRANCHE_BOOKING),
    bookingStatusFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_BOOKING_STATUS),
    deliveryPlanFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_DELIVERY_PLAN),
    tranchePlanViewFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_TRANCHE_PLAN_VIEW),
    trancheBookingDetailsFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_TRANCHE_BOOKING_DETAILS),
    budgetingPlannerFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_BUDGETING_PLANNER),
    budgetingPlannerPMFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_BUDGETING_PLANNER_PM),
    userFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_USERS),
    dictionaryFormConfig: FormsLoader.detectFormConfig(FORM_TYPE_DICTIONARY),

    localAssignedPermissions: [],
    filteredlocalAssignedPermissions: [],
    isChecked: false,
    localAssignedPermissionsStatus: false,
    allPerms: [],
    allPermissionsWhichHaveALocatedPlace: [],
    isListLeftActive: false,
    isListRightActive: false,

    seasonRequiredPermissions: [],
    seasonAvailableRequiredPermissions: [],
    seasonPermissionsStatus: false,
    seasonPermissionsDisabled: false,

    productRequiredPermissions: [],
    productAvailableRequiredPermissions: [],
    allProductAvailableRequiredPermissions: [],
    allSeasonAvailableRequiredPermissions: [],
    allOrderAvailableRequiredPermissions: [],
    allDictionaryAvailableRequiredPermissions: [],
    productPermissionsStatus: false,
    productPermissionsDisabled: false,

    orderAvailableRequiredPermissions: [],
    orderPermissionsStatus: false,
    orderPermissionsDisabled: false,
    orderRequiredPermissions: null,

    logisticsRequiredPermissions: [],
    logisticsAvailableRequiredPermissions: [],
    logisticsPermissionsStatus: false,
    logisticsPermissionsDisabled: false,

    budgetPlannerRequiredPermissions: [],
    budgetPlannerAvailableRequiredPermissions: [],
    budgetPlannerPermissionsStatus: false,
    budgetPlannerPermissionsDisabled: false,

    dictionariesRequiredPermissions: [],
    dictionariesAvailableRequiredPermissions: [],
    dictionariesPermissionsStatus: false,
    dictionariesPermissionsDisabled: false,

    usersRequiredPermissions: [],
    usersAvailableRequiredPermissions: [],
    usersPermissionsStatus: false,
    usersPermissionsDisabled: false,

    securedFieldsRequiredPermissions: [],
    securedFieldsAvailableRequiredPermissions: [],
    securedFieldsPermissionsStatus: false,
    securedFieldsPermissionsDisabled: false,

    othersRequiredPermissions: [],
    othersAvailableRequiredPermissions: [],
    othersPermissionsStatus: false,
    othersPermissionsDisabled: false,

    reportsRequiredPermissions: [],
    reportsAvailableRequiredPermissions: [],
    reportsPermissionsStatus: false,
    reportsPermissionsDisabled: false,

    allMainCheckboxStatus: false,
    checkList: false,

    lastQuery: "",
    searchAvailablePermissionsInput: "",
    searchAssignedPermissionsInput: "",
    searchAvailableOrderPermissionsInput: "",
    searchAvailableDictionaryPermissionsInput: "",
    searchAvailableProductPermissionsInput: "",
    searchAvailableSeasonPermissionsInput: "",
    statusColor: "text-secondary",
    searchAvailablePermissionsVisible: false,
    searchAssignedPermissionsVisible: false,
    loadAvailablePermissionsForFormMode: "None",
    loadAssignedPermissionsForFormMode: "None",
    numberOfAllAvailablePermissions: 0,
    numberOfAssignedPermissions: 0,
    whichSearchBarIsUsed: ""
  })
}
</script>
